import { Card } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { fmt } from "@/src/lib/utils";

export const Boosts = () => {
  const { nftBoost, unCharged } = useBalances();
  return (
    <Card>
      <div className="space-y-4">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
          Harvest Boosters
        </h2>

        <div className="text-center py-2">
          <p className="text-2xl sm:text-3xl font-bold text-foreground font-mono">
            {fmt(nftBoost/10000)}%
          </p>
          <p className="text-sm text-muted-foreground mt-1.5">NFT Boost</p>
        </div>

        {unCharged > 0 &&
          <div className="border border-warning/30 bg-warning/5 rounded-xl px-4 py-3 flex items-start gap-2.5">
            <span className="text-warning text-sm leading-none mt-0.5">⚠</span>
            <p className="text-sm text-warning/80 font-medium">
              You have uncharged NFTs
            </p>
          </div>
        }
      </div>
    </Card>
  );
};
